@if (isLoading) {
<app-loading-spinner text="Bids and Offers"></app-loading-spinner>
} @if (userDetails$ | async; as userDetails) {
<div
  class="py-2 px-4 page-height overflow-auto flex flex-col"
  (scroll)="onBidsAndOffersScroll($event)"
>
  <div class="flex flex-row justify-stretch items-center gap-4 mt-4 w-full">
    <mat-form-field appearance="outline" class="w-full">
      <mat-label>Search</mat-label>
      <input
        matInput
        (keyup)="searchList($event)"
        placeholder="Ex. Corn"
        #input
      />
    </mat-form-field>
    <!-- no longer used bc market selectino is in nav bar -->
    <!-- @if (userDetails.market_options.length) {
    <span>
      @if (userDetails.market_options.length > 1) {
      <mat-form-field class="w-full" appearance="outline">
        <mat-label>Select Market</mat-label>
        <mat-select
          [value]="selectedMarket()"
          (selectionChange)="getLots($event.value)"
        >
          @for (option of userDetails.market_options; track option; let i =
          $index) {
          <mat-option [value]="option">
            @switch(option){ @case ('Farm'){ FOB Farm }@case('Feed'){DOMESTIC}
            @default {
            {{ option | uppercase }}} }
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
      }
    </span>
    } -->
  </div>
  <div class="flex-1 pb-20">
    @for (item of filteredLots$ | async; track item._id) {
    <div>
      <mat-card
        [ngClass]="{
          highlight: newLotIds?.includes(item._id),
          'bg-white': !newLotIds?.includes(item._id)
        }"
        class="lot-item p-4 my-2 mx-auto max-w-xl"
      >
        <a [routerLink]="[item.broker_indication ? '' : item._id]">
          <div class="flex justify-between items-center">
            <div class="text-lg font-medium">
              {{ item.commodity }} - {{ item.grade }}
            </div>
            <mat-chip-set class="flex flex-row justify-center items-center">
              @if(item.hasNegotiations){
              <fa-icon
                [icon]="faHandShake"
                size="lg"
                [style]="{ color: '#ff9500', padding: '5px' }"
              ></fa-icon>
              } @if (userDetails._id == item.user_id) {
              <mat-chip
                aria-label="sent-counter"
                disableRipple="true"
                class="text-xs purple-chip p-0 m-0"
                >My
              </mat-chip>
              } @if(!item.broker_indication ){
              <mat-chip
                class="text-xs m-0"
                disableRipple="true"
                [ngClass]="{
                  'blue-chip': item.lot_type === 'Offer',
                  'green-chip': item.lot_type === 'Bid'
                }"
              >
                {{ item.lot_type }}
              </mat-chip>
              } @if (item.indication && !item.broker_indication) {
              <mat-chip
                disableRipple="true"
                class="text-xs light-blue-chip p-0"
                matTooltip="Bid/Offer indication represents a non-binding expression of interest from a buyer (bid) or seller (offer) to transact at a specific price or within a price range."
                aria-label="Button that displays a tooltip when focused or hovered over"
                >Indication
              </mat-chip>
              }
              <app-jc-trading-indication
                [showIndication]="item.broker_indication"
              />
            </mat-chip-set>
          </div>
          <div class="flex justify-between items-center">
            @if ( item.ship_begin.split('-')[0] == item.ship_end.split('-')[0])
            {
            <div class="text-sm">
              {{ item.ship_begin | date : "MMM d" }} -
              {{ item.ship_end | date : "MMM d, y" }}
            </div>
            } @else {
            <div class="text-sm">
              {{ item.ship_begin | date : "MMM d, y" }} -
              {{ item.ship_end | date : "MMM d, y" }}
            </div>
            }
            <div class="text-sm font-medium">
              {{ item.volume_value }}
              {{ item.units === "Metric Tonnes" ? "MT" : item.units }}
            </div>
          </div>
          <div class="flex justify-between items-center">
            <div class="text-sm">
              {{ item.destination }} ({{ item.delivery_type }})
            </div>
            <div class="text-sm font-medium">
              @if(item.indication){~}
              {{ item.currency }} ${{ item.price | priceType }} /
              {{ item.price_units }}
            </div>
          </div>
        </a>
      </mat-card>
    </div>
    }
  </div>
  <div
    *appBlockUserRoles="['viewer']"
    class="fixed bottom-3 left-0 right-0 flex justify-center z-10"
  >
    @if (selectedMarket() !== 'Farm') {
    <a [routerLink]="'new/bid'" class="mr-2">
      <div
        class="button-transition bg-custom-green text-white text-md p-4 rounded-full flex items-center justify-center w-40"
        [style.opacity]="buttonOpacity"
      >
        New Bid
      </div>
    </a>
    }
    <a *appBlockUserRoles="['viewer']" [routerLink]="'new/offer'" class="ml-2">
      <div
        class="button-transition bg-custom-blue text-white text-md p-4 rounded-full flex items-center justify-center w-40"
        [style.opacity]="buttonOpacity"
      >
        New Offer
      </div>
    </a>
  </div>
</div>
}
